// src/components/HotelPage/PricingExplainer.jsx
import { useTranslation, Trans } from 'react-i18next';
import { usePricing, baseStayPrice } from '../../utils/pricing';

const formatMXN = (amount) =>
  amount.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

// Explica la lógica de precio y menciona el programa de recompensas. Los
// números vienen de macarios-api/config/pricing.js, así que se actualizan
// solos cuando cambian los precios.
const PricingExplainer = () => {
  const { t } = useTranslation('common');
  const pricing = usePricing();
  const minNights = pricing?.minNights ?? 2;
  const startingPrice = baseStayPrice(pricing, minNights);
  // [0, 0.5, 0.75] -> "50%" para el 2o perro, "75%" del 3o en adelante
  const [, secondDogDiscount, ...laterDiscounts] = pricing?.dogDiscounts ?? [];
  const thirdDogDiscount = laterDiscounts.length ? laterDiscounts[0] : secondDogDiscount;
  const pct = (d) => `${Math.round(d * 100)}%`;

  return (
  <section className="bg-white py-16 sm:py-24">
    <div className="max-w-3xl mx-auto px-4">
      <div className="text-center mb-10">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9A0002]">
          {t('hotelPage.step2')}
        </span>
        <h2 className="mt-2 font-['Fraunces'] text-3xl sm:text-4xl font-semibold text-[#3A2A20]">
          {t('hotelPage.pricingTitle')}
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="bg-[#EFE6DD]/50 rounded-2xl p-6 border border-[#9A0002]/10">
          <p className="font-['Fraunces'] text-2xl font-semibold text-[#9A0002]">
            {startingPrice !== null ? `$${formatMXN(startingPrice)}` : '—'}{' '}
            <span className="text-sm font-sans font-normal text-[#3A2A20]/50">mxn</span>
          </p>
          <p className="text-sm text-[#3A2A20]/70 mt-2">
            {t('hotelPage.minStayPrice', { nights: minNights })}
          </p>
        </div>
        <div className="bg-[#EFE6DD]/50 rounded-2xl p-6 border border-[#9A0002]/10">
          <p className="font-['Fraunces'] text-2xl font-semibold text-[#3A2A20]">
            {t('hotelPage.dropsTitle')}
          </p>
          <p className="text-sm text-[#3A2A20]/70 mt-2">
            {t('hotelPage.dropsDesc')}
            {secondDogDiscount > 0 && (
              <>
                {' '}
                {thirdDogDiscount > 0
                  ? t('hotelPage.dogDiscount', { second: pct(secondDogDiscount), later: pct(thirdDogDiscount) })
                  : t('hotelPage.dogDiscountSecondOnly', { second: pct(secondDogDiscount) })}
              </>
            )}
          </p>
        </div>
      </div>

      <div className="mt-6 bg-[#9A0002]/5 rounded-2xl p-6 border border-[#9A0002]/10 text-center">
        <p className="text-sm text-[#3A2A20]/80">
          <Trans t={t} i18nKey="hotelPage.rewards" components={{ bold: <strong /> }} />
        </p>
      </div>
    </div>
  </section>
  );
};

export default PricingExplainer;